module.exports = __webpack_public_path__ + "static/media/game-treatment.c11275c3.md";